import constant from "@/common/constant";
import store from "@/store";
import AxiosStatic from "../plugins/axios";

class GlobalService {
	static get defaultConfig() {
		return {
			"Content-Type": "application/json",
		};
	}
	onReject(error) {
		console.error("onReject -> error", error);
	}
	constructor() {
		this.axios = AxiosStatic;
	}
	async getLocalData_Async(
		url,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}

		let _url = await Promise.resolve(url);
		let response;
		try {
			response = await this.axios(
				{
					url: _url,
					method: "GET",
				},
				config,
			);
			return response.data;
		} catch (reason) {
			if (reject instanceof Function) {
				return reject(reason);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 *
	 * @param {string} url
	 * @param {object} config
	 * @param {Function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async getData_Async(
		url,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;

		try {
			response = await this.axios({
				url: _url,
				method: "GET",
				config,
			});
			return response.data;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}
	async getDataBlob_Async(
		url,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;

		try {
			response = await this.axios({
				url: _url,
				method: "GET",
				responseType: "blob",
				config,
			});
			return response.data;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}
	async postDataBlob_Async(
		url,
		data,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;

		try {
			response = await this.axios(
				{
					url: _url,
					method: "POST",
					responseType: "blob",
					data: data,
				},
				config,
			);
			return response.data;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}
	async getData_AsyncWithHeader(
		url,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;
		try {
			response = await this.axios(
				{
					url: _url,
					method: "GET",
				},
				config,
			);
			return response;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}
	/**
	 *
	 * @param {string} url
	 * @param {Object} config
	 * @param {Function} reject
	 * @returns
	 */
	async getDataOutside_Async(
		url,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(url);
		let response;
		try {
			response = await this.axios(
				{
					url: _url,
					method: "GET",
				},
				config,
			);
			return response.data;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 *
	 * @param {string} url
	 * @param {Object} config
	 * @param {Function} reject
	 * @returns
	 */
	async downloadBlob_Async(
		url,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(url);
		let response;
		try {
			response = await this.axios(
				{
					url: _url,
					method: "GET",
					responseType: "blob",
				},
				config,
			);
			return response.data;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 * @param {string} url
	 * @param {object} data
	 * @param {object} config
	 * @param {function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async postData_Async(
		url,
		data,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;
		try {
			response = await this.axios(
				{
					url: _url,
					method: "POST",
					data: data,
				},
				config,
			);
			return response.data;
		} catch (reason) {
			if (reject instanceof Function) {
				return reject(reason);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 * @param {string} url
	 * @param {object} data
	 * @param {object} config
	 * @param {function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async postDataOutside_Async(
		url,
		data,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(url);
		let response;
		try {
			response = await this.axios(
				{
					url: _url,
					method: "POST",
					data: data,
				},
				config,
			);
			return response.data;
		} catch (reason) {
			if (reject instanceof Function) {
				return reject(reason);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	getData_NoAsync(
		url,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = false,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = store.state.config.apiUrl + url;
		return this.axios.get(_url, config).catch((reason) => {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
			if (reject instanceof Function) {
				return reject(reason);
			}
			return null;
		});
	}

	/**
	 * @param {string} url
	 * @param {object} data
	 * @param {object} config
	 * @param {function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async putData_Async(
		url,
		data,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let response;
		try {
			let _url = await Promise.resolve(store.state.config.apiUrl + url);
			response = await this.axios(
				{
					url: _url,
					method: "PUT",
					data: data,
				},
				config,
			);
			return response.data;
		} catch (reason) {
			if (reject instanceof Function) {
				return reject(reason);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 * @param {string} url
	 * @param {object} data
	 * @param {object} config
	 * @param {function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async deleteData_Async(
		url,
		data = {},
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let response;
		try {
			let _url = await Promise.resolve(store.state.config.apiUrl + url);
			response = await this.axios(
				{
					url: _url,
					method: "DELETE",
					data: data,
				},
				config,
			);
			return response.data;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 * @param {string} url
	 * @param {object} data
	 * @param {object} config
	 * @param {function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async patchData_Async(
		url,
		data,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(url);
		let response;
		try {
			response = await this.axios(
				{
					url: _url,
					method: "PATCH",
					data: data,
				},
				config,
			);
			return response.data;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 *
	 * @param {string} url
	 * @param {File} file
	 * @param {AxiosRequestConfig} config
	 * @param {Function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async upload_Async(
		url,
		file,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;
		let formData = new FormData();
		formData.append("file", file);
		try {
			response = await this.axios(
				{
					url: _url,
					method: "POST",
					data: formData,
				},
				config,
			);
			return response.data;
		} catch (error) {
			reject(error);
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 *
	 * @param {string} url
	 * @param {File} file
	 * @param {Object} data
	 * @param {AxiosRequestConfig} config
	 * @param {Function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async uploadData_Async(
		url,
		file,
		data,
		config = {},
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;
		let formData = new FormData();
		formData.append(constant.keys.file, file);
		for (let key of Object.keys(data)) {
			formData.append(key, JSON.stringify(data[key]));
		}
		try {
			// Build axios config properly
			const axiosConfig = {
				url: _url,
				method: "POST",
				data: formData,
				// Don't set Content-Type for FormData - let axios handle it automatically
				headers: {
					// FormData will set multipart/form-data automatically
					// Don't override with application/json for file uploads
				},
			};

			// Add progress callback if provided in config
			if (config.onUploadProgress) {
				axiosConfig.onUploadProgress = config.onUploadProgress;
			}

			// Pass the complete config to your axios instance
			response = await this.axios(axiosConfig, config);

			return response.data;
		} catch (error) {
			reject(error);
			throw error; // Re-throw to allow component to handle it
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}
	async uploadData_Async2(
		url,
		file,
		data,
		config = {},
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;
		let formData = new FormData();
		formData.append(constant.keys.file, file);
		for (let key of Object.keys(data)) {
			formData.append(key, data[key]);
		}
		try {
			response = await this.axios(
				{
					url: _url,
					method: "POST",
					data: formData,
				},
				config,
			);
			return response.data;
		} catch (error) {
			reject(error);
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 *
	 * @param {string} url
	 * @param {File} file
	 * @param {Object} data
	 * @param {AxiosRequestConfig} config
	 * @param {Function} reject
	 * @returns {{state:false,message:"",data:{}}}
	 */
	async uploadDataParameter_Async(
		url,
		file,
		data,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;
		let formData = new FormData();
		formData.append(constant.keys.file, file);
		try {
			response = await this.axios(
				{
					url: _url,
					method: "POST",
					data: formData,

					params: data,
				},
				config,
			);
			return response.data;
		} catch (error) {
			reject(error);
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	async updateFile_Async(
		url,
		file,
		config = GlobalService.defaultConfig,
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(store.state.config.apiUrl + url);
		let response;
		let formData = new FormData();
		formData.append(constant.keys.file, file);
		try {
			response = await this.axios(
				{
					url: _url,
					method: "PUT",
					data: formData,
				},
				config,
			);
			return response.data;
		} catch (error) {
			reject(error);
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	}

	/**
	 * Runs promises in batches with allSettled semantics.
	 * @param {Array<Function>} tasks - Array of functions that return a Promise when called
	 * @param {number} batchSize - Number of concurrent promises per batch
	 * @returns {Promise<Array<PromiseSettledResult>>}
	 */
	async runInBatches(tasks, batchSize = 10) {
		const results = [];

		for (let i = 0; i < tasks.length; i += batchSize) {
			const batchTasks = tasks.slice(i, i + batchSize);

			// Call each task to get its Promise, then wait for all to settle
			const batchResults = await Promise.allSettled(
				batchTasks.map((task) => task()),
			);
			results.push(...batchResults);
		}

		return results;
	}
}

const globalService = new GlobalService();

export default globalService;
